import Values from './Values';

export default Values;
